import Bugsnag from '@bugsnag/js'
import BugsnagPerformance from '@bugsnag/browser-performance'

function getMeta(name) {
  const tag = document.querySelector(`meta[name="${name}"]`)
  return tag ? tag.content : undefined
}

const apiKey = 'a71ba2fe4f490eaa55cd905e14165121'

if (window.location.hostname.includes('mtggoldfish.com')) {
  Bugsnag.start({
    apiKey,
    onError: event => {
      event.setUser(getMeta('bugsnag-user-id'))

      // Drop errors where no stack frame is from our own domain or webpack
      // bundle (e.g. errors originating entirely from ad-network scripts).
      const frames = event.errors?.[0]?.stacktrace ?? []
      const hasFirstPartyFrame = frames.some(f =>
        f.file && (f.file.includes('mtggoldfish.com') || f.file.startsWith('webpack://'))
      )
      if (!hasFirstPartyFrame) return false

      return true
    }
  })

  BugsnagPerformance.start({ apiKey })
}
